import { Box, Button, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { SortingCenter } from 'types';
import { colors } from 'theme';

const useStyles = makeStyles(theme => ({
  sortingCenterButton: {
    padding: '1.5em 4em',
    border: '1px solid #E9EDEF',
    fontWeight: 600,
    textAlign: 'left',
    marginBottom: '2em',
    minHeight: '7em',
  },
  sortingCenterName: {
    fontWeight: 600,
  },
  disabled: {
    color: colors.greyBlue,
  },
  primary: {
    color: theme.palette.primary.main,
  },
  darkGrey: {
    color: '#626469',
  },
  roleWrapper: {
    fontSize: '18px',
    textTransform: 'none',
    fontWeight: 600,
  },
  role: {
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  arrowButton: {
    color: colors.neutralGray,
  },
}));

export interface SortingCenterChildrenChildrenProps {
  sortingCenter: SortingCenter;
  userRole: string;
  selectSortingCenter: (sortingCenter: SortingCenter) => void;
}

export const SortingCenterChildren: React.FC<SortingCenterChildrenChildrenProps> = ({
  sortingCenter,
  selectSortingCenter,
  userRole,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button
      className={classes.sortingCenterButton}
      onClick={() => selectSortingCenter(sortingCenter)}
      variant="outlined"
      fullWidth
      key={sortingCenter['@id']}
      endIcon={<ArrowForwardIcon className={classes.arrowButton} />}
    >
      <Box flexDirection="column" flexGrow={1}>
        <Typography
          component="p"
          className={classNames(classes.sortingCenterName, {
            [classes.disabled]: !sortingCenter.isActive,
          })}
        >
          {sortingCenter.name} -{' '}
          <span
            className={classNames({
              [classes.primary]: sortingCenter.isActive,
              [classes.disabled]: !sortingCenter.isActive,
            })}
          >
            {sortingCenter.code}
          </span>
        </Typography>
        <Typography
          className={classNames(classes.roleWrapper, {
            [classes.darkGrey]: sortingCenter.isActive,
            [classes.disabled]: !sortingCenter.isActive,
          })}
        >
          {t('sortingCenterSelection.yourRole')}{' '}
          <Typography color={sortingCenter.isActive ? 'primary' : undefined} component="span" className={classes.role}>
            {t(`users.rolesEnum.${userRole}`)}
          </Typography>
        </Typography>
      </Box>
    </Button>
  );
};
